import Heading from '@atlaskit/heading';
import { Grid, Inline, media, Stack, xcss } from '@atlaskit/primitives';
import type { PreloadedQuery } from 'react-relay';
import { graphql, usePreloadedQuery } from 'react-relay';

import { type assignedToMeQuery } from './__generated__/assignedToMeQuery.graphql';
import { Card } from './card';

export const AssignedToMe = ({ queryRef }: { queryRef: PreloadedQuery<assignedToMeQuery> }) => {
	const data = usePreloadedQuery<assignedToMeQuery>(
		graphql`
			query assignedToMeQuery($cloudId: ID!, $jql: String) {
				jira {
					issueSearch(cloudId: $cloudId, issueSearchInput: { jql: $jql })
						@optIn(to: "JiraSpreadsheetComponent-M1") {
						edges {
							node {
								id
								key
								...card_fragment
							}
						}
					}
				}
			}
		`,
		queryRef,
	);

	return (
		<Stack space="space.200" alignInline="start">
			<Inline alignBlock="center" spread="space-between" grow="fill" shouldWrap>
				{/* eslint-disable-next-line @dev-agents/rules/i18n/text-wrapped-in-format-message */}
				<Heading size="small">Assigned to me</Heading>
			</Inline>

			<Grid xcss={responsiveStyles} columnGap="space.200" rowGap="space.200" alignItems="center">
				{data?.jira?.issueSearch?.edges?.map(
					(edge) => edge?.node && <Card key={edge?.node.key} issue={edge?.node} />,
				)}
			</Grid>
		</Stack>
	);
};

const responsiveStyles = xcss({
	[media.above.xxs]: { gridTemplateColumns: 'repeat(1, 1fr)' },
	[media.above.sm]: {
		gridTemplateColumns: 'repeat(2, 1fr)',
	},
	[media.above.md]: {
		gridTemplateColumns: 'repeat(3, 1fr)',
	},
	[media.above.lg]: {
		gridTemplateColumns: 'repeat(4, 1fr)',
	},
	[media.above.xl]: {
		gridTemplateColumns: 'repeat(5, 1fr)',
	},
});
